import { getAnimatableEndEvent } from '@/utils/dom';

// get the transitionend event name for cross browser compatibility
const transitionEndEvent = getAnimatableEndEvent('transition');

export default {
  bind(el) {
    // register a 'transitionend' handler to remove the animatable class
    el.addEventListener(transitionEndEvent, transitionEnd, false);
  },

  update(el, { value: isOpened, oldValue: wasOpened }) {
    // terminate the hook handler if nothing has changed
    if (isOpened === wasOpened) {
      return false;
    }

    const offCanvas = document.querySelector(el.dataset.offCanvas);

    offCanvas.classList.add(el.dataset.animateClass);

    if (isOpened) {
      offCanvas.classList.add(el.dataset.openedClass);
    } else {
      offCanvas.classList.remove(el.dataset.openedClass);
    }
  },

  unbind(el) {
    // remove transitionEnd handler from transitionend event
    el.removeEventListener(transitionEndEvent, transitionEnd, false);
  },
};

export function transitionEnd(e) {
  // the handler should run only if the target is the nav menu itself
  if (e.target !== this) {
    return false;
  }

  document
    .querySelector(this.dataset.offCanvas)
    .classList.remove(this.dataset.animateClass);
}
